/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_Reset_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Reset the round clock?" |
*
* @param {Timer_Reset_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_reset_confirm_title = /** @type {((inputs?: Timer_Reset_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Reset_Confirm_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialiser l'horloge de ronde ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Reiniciar el reloj de ronda?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reiniciar o relógio da rodada?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimpostare l'orologio del round?")
	return /** @type {LocalizedString} */ ("Reset the round clock?")
});